import { makeRequestDeduped } from '../../../infra/rest';
import { PlanApiResponse } from '../typings';

export const fetchCurrentPlan = async (): Promise<PlanApiResponse> => {
  return await makeRequestDeduped<PlanApiResponse>(`/v1/plan/features`, {}, true);
};
